import React from 'react';
import { useLanguage } from '../../../language/hooks/useLanguageHook';
import { platformIntegrations } from '../../data/landingPageData'; // Import platform data

const IntegrationSection = () => {
  const { t } = useLanguage();

  return (
    <div className="relative z-10 bg-white py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16 scroll-fade-in">
          <h2 className="text-4xl font-bold mb-4">{t("public.landing.integration.title")}</h2>
          <p className="text-xl text-gray-600">{t("public.landing.integration.subtitle")}</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 scroll-slide-in">
          {platformIntegrations.map((platform) => (
            <div
              key={platform.nameKey} // Use nameKey as the unique identifier
              className="bg-white rounded-xl p-8 border border-gray-100 hover:border-blue-300 transition-all duration-300 ease-in-out hover:shadow-lg group"
            >
              <div className="flex flex-col items-center justify-center h-full">
                <div className="relative w-full flex items-center justify-center mb-4 transform group-hover:scale-105 transition-transform duration-300 ease-in-out h-16"> {/* Added fixed height container */}
                  <img
                    src={platform.logo}
                    alt={t(platform.nameKey)} // Translate alt text
                    className={`${platform.className} object-contain max-h-full`} // Ensure image fits container
                  />
                </div>
                <p className="font-medium text-center text-gray-700 group-hover:text-blue-600 transition-colors">
                  {t(platform.nameKey)} {/* Translate platform name */}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IntegrationSection; 